// extracted by mini-css-extract-plugin
export default {"scope":"wexYo","overlay":"Qbzhq","root-directories":"Mg4qK"};